import { goalsApi } from '../apis';

import type { AxiosResponse } from 'axios';
import { Goal } from '../core/types/goals.types';

export const getGoal = async (goalId: string): Promise<AxiosResponse<Goal>> =>
  goalsApi.get<Goal>(`goal-config/${goalId}`);
